import script from "./CardNoticia.vue?vue&type=script&setup=true&lang=js"
export * from "./CardNoticia.vue?vue&type=script&setup=true&lang=js"

import "./CardNoticia.vue?vue&type=style&index=0&id=7456ff76&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7456ff76"]])

export default __exports__